import { render, staticRenderFns } from "./CreateCStoPO.vue?vue&type=template&id=9d5899f2&"
import script from "./CreateCStoPO.vue?vue&type=script&lang=js&"
export * from "./CreateCStoPO.vue?vue&type=script&lang=js&"
import style0 from "./CreateCStoPO.vue?vue&type=style&index=0&id=9d5899f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports